export enum OrderOptimizerDetailsUpdateRequestStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerDetailsUpdateRequestBody = {
  status?: OrderOptimizerDetailsUpdateRequestStatus;
};

type OrderOptimizerDetailsUpdateRequest = {
  id: string;
  status?: OrderOptimizerDetailsUpdateRequestStatus;
};

export default OrderOptimizerDetailsUpdateRequest;
